<template>
  <a-row style="width:100%;height:100%;">
    <a-col
      :span="14"
      style="height:100%;"
    >
      <div
        id="testMap"
        style="width:100%;height:100%;"
      >
        <style-setting ref="styleSettingC"></style-setting>
      </div>
    </a-col>
    <a-col
      :span="10"
      style="height:100%;"
    >
      {{nowDate}}
      <a-button
        icon="print"
        style="margin-left:5px;"
        @click="printMap"
      >打印</a-button>
      <img
        :src="printImage"
        style="width:100%;height:400px;"
      />
    </a-col>
  </a-row>

</template>
<script>
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import { Map, View } from "ol";
import TileWMS from 'ol/source/TileWMS';
import Projection from 'ol/proj/Projection';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import * as olControl from 'ol/control';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import TileGrid from 'ol/tilegrid/TileGrid';
import WMTS from 'ol/source/WMTS';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import VectorTile from 'ol/source/VectorTile';
import VectorLayer from 'ol/layer/Vector';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import StyleSetting from '../components/StyleSetting.vue';
import { WFS, GeoJSON } from 'ol/format';
import format from 'date-fns/format';
import { zhCN } from 'date-fns/locale';
import Print from 'ol-ext/control/Print';
import { saveAs } from 'file-saver';



export default {
  name: 'Test',
  components: {
    StyleSetting,
  },
  data() {
    return {
      nowDate: format(new Date(), "yyyy-MM-dd HH:mm:ss cccc", { locale: zhCN }),
      ntTotal: 12323232.3434343,
      printControl: {},
      printImage: ""
    }
  },
  methods: {
    initTestMap() {
      proj4.defs("EPSG:4490", "+proj=longlat +ellps=GRS80 +no_defs");
      register(proj4);
      const projection = new Projection({
        code: "EPSG:4490",
        units: 'degrees',
        extent: [-180.0, -90.0, 180.0, 90.0]
      });

      let matrixIds = new Array(21);
      for (let i = 0; i < 21; ++i) {
        matrixIds[i] = i;
      }
      const tileGrid = new WMTSTileGrid({
        origin: [-180, 90], //原点（左上角）
        resolutions: [
          1.40625,
          0.703125,
          0.3515625,
          0.17578125,
          0.087890625,
          0.0439453125,
          0.02197265625,
          0.010986328125,
          0.0054931640625,
          0.00274658203125,
          0.001373291015625,
          6.866455078125E-4,
          3.4332275390625E-4,
          1.71661376953125E-4,
          8.58306884765625E-5,
          4.291534423828125E-5,
          2.1457672119140625E-5,
          1.0728836059570312E-5,
          5.364418029785156E-6,
          2.682209064925356E-6,
          1.3411045324626732E-6
        ], //分辨率数组
        matrixIds: matrixIds,//矩阵标识列表，与地图级数保持一致
        // extent: [118.494842914869, 31.6225778674747, 119.114502613405, 32.1083056247049]
        extent: [-180.0, -90.0, 180.0, 90.0]
      });

      const baseLayer = new TileLayer({
        source: new XYZ({
          projection: projection, //数据的投影坐标系
          //瓦片网格对象
          tileGrid: tileGrid,
          tileUrlFunction: function (tileCoord) {
            var z = tileCoord[0];
            var x = tileCoord[1];
            var y = tileCoord[2];
            return `http://58.213.148.61:8089/geostar/JN_JZWST/wmts?LAYER=JN_JZWST&FORMAT=protobuf&TILEMATRIXSET=JN_JZWST_Matrix_0&VERSION=1.0.0&TILEMATRIX=${z}&TILEROW=${y}&TILECOL=${x}&service=WMTS&request=GetTile`;
          },
          style: 'JNVTS_Style.JN_LTFW',
          wrapX: true
        })
      });

      // const baseLayer = new TileLayer({
      //   source: new WMTS({
      //     url: 'http://58.213.148.61:8089/geostar/JN_LTFW/wmts', //WMTS服务基地址
      //     layer: "JN_LTFW",
      //     matrixSet: 'JN_LTFW_Matrix_0', //投影坐标系设置矩阵
      //     format: 'image/jpeg', //图片格式
      //     projection: projection, //数据的投影坐标系
      //     //瓦片网格对象
      //     tileGrid: tileGrid,
      //     style: 'JNVTS_Style.JN_LTFW',
      //     wrapX: true
      //   })
      // });
      const map = new Map({
        target: 'testMap',
        layers: [baseLayer],
        controls: olControl.defaults({
          zoom: false
        }),
        view: new View({
          projection: projection,
          center: [118.875281, 31.91083728],
          zoom: 19,
          minZoom: 2,
          maxZoom: 20
        })
      });
    },
    initTestMap2() {
      proj4.defs('EPSG:990000', '+proj=tmerc +lat_0=39.865766 +lon_0=116.35025181 +k=1 +x_0=500000 +y_0=300000 +ellps=krass +towgs84=15.8,-154.4,-82.3,0,0,0,0 +units=m +no_defs');
      register(proj4);
      const projection = new Projection({
        code: "EPSG:990000",
        units: 'meters',
        extent: [418170.1454912898, 252703.74012962537, 604717.8718097142, 439155.05878358183]
      });

      //切片名
      const matrixIds = ['EPSG:990000:0', 'EPSG:990000:1', 'EPSG:990000:2',
        'EPSG:990000:3', 'EPSG:990000:4', 'EPSG:990000:5', 'EPSG:990000:6',
        'EPSG:990000:7', 'EPSG:990000:8', 'EPSG:990000:9', 'EPSG:990000:10',
        'EPSG:990000:11', 'EPSG:990000:12', 'EPSG:990000:13'];
      //分辨率
      const resolutions = [728.7020559313455, 364.35102796567276, 182.17551398283638,
        91.08775699141819, 45.543878495709095, 22.771939247854547,
        11.385969623927274, 5.692984811963637, 2.8464924059818184,
        1.4232462029909092, 0.7116231014954546, 0.3558115507477273,
        0.1779057753738637, 0.0889528876869318]

      //切片策略
      const tilegrid = new WMTSTileGrid({
        extent: [418170.1454912898, 252703.74012962537, 604717.8718097142, 439155.05878358183],//范围
        tileSize: [256, 256],
        origin: [418170.1454912898, 439251.4664480498],
        resolutions: resolutions,//分辨率
        matrixIds: matrixIds//层级标识列表，与地图级数保持一致
      });
      const tileSource = new WMTS({
        url: 'http://localhost:8080/geoserver/gwc/service/wmts',
        layer: "chs:zzy_base",
        format: "image/png",
        matrixSet: "EPSG:990000",
        projection: projection,
        tileGrid: tilegrid,
        crossOrigin: "Anonymous"
      });
      const baseLayer = new TileLayer({ 
        id: "base_layer_0",
        source: tileSource,
        wrapX: false
      });
      const tmpLayer = new TileLayer({
        source: new TileWMS({
          url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
          params: {
            'LAYERS': "chs:20201231034745487",
            'TILED': true
          },
          serverType: 'geoserver',
          transition: 0
        })
      });


      const map = new Map({
        target: 'testMap',
        layers: [baseLayer, tmpLayer],
        controls: olControl.defaults({
          zoom: false
        }),
        view: new View({
          projection: projection,
          center: [516744.69646686607, 39.61265047974838],
          zoom: 10,
          minZoom: 6,
          maxZoom: 13,
        })
      });
      map.getView().fit([516744.69646686607, 271908.6260283868, 526115.3334452512, 285207.00024038646], map.getSize());


      this.printControl = new Print();
      map.addControl(this.printControl);
      this.initPrintListener();
    },
    initPrintListener() {
      this.printControl.on('printing', (e) => {
        // console.log(e);
      });
      this.printControl.on(['print', 'error'], (e) => {
        if (e.image) {
          this.printImage = e.image;
          //for ie 11+
          if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
              value: function (callback, type, quality) {
                var canvas = this;
                setTimeout(function () {
                  var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
                  var len = binStr.length;
                  var arr = new Uint8Array(len);

                  for (var i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                  }

                  callback(new Blob([arr], { type: type || 'image/png' }));
                });
              }
            });
          }
          
          e.canvas.toBlob((blob) => {
            saveAs(blob, 'map.' + e.imageType.replace('image/', ''));
          }, e.imageType);
        } else {
          console.warn('No canvas to export');
        }
      });
    },
    printMap() {
      this.printControl.print({ imageType: 'image/png', quality: 0.1 });
    },
    gradientColor(f, t, n) {
      return [...Array(++n + 1)].map((_, i) => f.replace(/../g, (e, j) => ((`0x${e}` * (n - i) + `0x${t[j] + t[j + 1]}` * i) / n | 256).toString(16).slice(1)));
    },
  },
  mounted() {
    // const colors = this.gradientColor("ffffff", "08306b", 10);
    // console.log(colors);
    // let j = 1;
    // colors.forEach(color => {
    //   const div = document.createElement("div");
    //   div.style.position = "absolute";
    //   div.style.left = "0px";
    //   div.style.width = "50px";
    //   div.style.height = "50px";
    //   div.style.border = "1px solid #ddd";
    //   div.style.backgroundColor = "#" + color;
    //   div.innerText = color;
    //   div.style.top = ((j - 1) * 50 + 10) + "px";
    //   // document.body.appendChild(div);
    //   j++;
    // })
    setTimeout(() => {
      this.initTestMap2();
      this.$refs.styleSettingC.$emit("showThis", { "layer": "20201231034745487" });


    }, 1000);
  }
}
</script>